import type { PaletteOptions } from '@mui/material/styles';

// ISS Brand Colors (copied from original project)
export const brandColors = {
  primary: {
    light: 'rgb(90, 147, 211)',
    main: 'rgb(36, 90, 165)',
    dark: 'rgb(10, 62, 144)',
    contrastText: 'rgb(59, 115, 187)',
  },
  secondary: {
    main: 'rgba(61, 134, 190, 0.15)',
    light: 'rgba(199, 199, 199, 1)',
    dark: 'rgb(0, 0, 0)',
    contrastText: 'rgb(226, 237, 245)',
  },
  info: {
    main: 'rgba(255, 255, 255, 1)',
    light: 'rgba(246, 246, 246, 1)',
    dark: 'rgba(122, 122, 122, 1)',
    contrastText: 'rgba(61, 134, 190, 0.15)',
  },
  success: {
    main: 'rgba(22, 171, 52, 1)',
    light: 'rgba(222, 247, 236, 1)',
    dark: '#1b5e20',
    contrastText: '#ffffff',
  },
  error: {
    main: 'rgba(229, 84, 84, 1)',
    light: 'rgba(254, 226, 226, 1)',
    dark: 'rgba(153, 27, 27, 1)',
    contrastText: '#ffffff',
  },
  warning: {
    main: 'rgba(154, 52, 18, 1)',
    light: 'rgba(255, 237, 213, 1)',
    dark: '#e65100',
    contrastText: '#ffffff',
  },
};

export const lightPalette: PaletteOptions = {
  mode: 'light',
  primary: brandColors.primary,
  secondary: brandColors.secondary,
  success: brandColors.success,
  warning: brandColors.warning,
  error: brandColors.error,
  info: brandColors.info,
  background: {
    default: '#ffffff',
    paper: '#ffffff',
  },
  text: {
    primary: 'rgba(0, 0, 0, 0.87)',
    secondary: 'rgba(0, 0, 0, 0.6)',
    disabled: 'rgba(0, 0, 0, 0.38)',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  action: {
    active: 'rgba(0, 0, 0, 0.54)',
    hover: 'rgba(0, 0, 0, 0.04)',
    selected: 'rgba(0, 0, 0, 0.08)',
    disabled: 'rgba(0, 0, 0, 0.26)',
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
  },
};
